function isRegExp(value) {
    return value instanceof RegExp;
}

export { isRegExp };
